import { SerializedError } from '@reduxjs/toolkit';
import Axios, { CancelTokenSource } from 'axios';
import { getApi } from '../apiClient';
import { FILTER_SEARCH } from './constants';
import {
  ICoursesCatalog,
  ICoursesCatalogGetResponse,
  ILessonsCatalog,
  ILessonsCatalogGetResponse,
  ISkillGetResponse
} from './types';

const REQUEST_IS_CANCELED_MESSAGE = 'This request was canceled due to a new request';
const LESSONS_PER_PAGE = '20';
const COURSES_PER_PAGE = '4';
const { CancelToken } = Axios;

let lessonCatalogCancelToken: CancelTokenSource;
let courseCatalogCancelToken: CancelTokenSource;

export const isRequestCanceled = (error: SerializedError): boolean =>
  error.message === REQUEST_IS_CANCELED_MESSAGE;

export async function fetchCoursesCatalog(
  filterUrlString: string,
  page?: ICoursesCatalog['nextPage']
): Promise<ICoursesCatalogGetResponse> {
  if (courseCatalogCancelToken !== undefined) {
    courseCatalogCancelToken.cancel(REQUEST_IS_CANCELED_MESSAGE);
  }

  courseCatalogCancelToken = CancelToken.source();

  const searchParams = new URLSearchParams(filterUrlString);
  const searchValue = searchParams.get(FILTER_SEARCH);

  if (searchValue) {
    searchParams.delete(FILTER_SEARCH);
    searchParams.append('q[title_cont]', searchValue);
  }

  if (page !== null && page !== undefined) {
    searchParams.append('page', page.toString());
  }
  searchParams.append('per_page', COURSES_PER_PAGE);

  const { data } = await getApi().get('/courses', {
    params: searchParams,
    cancelToken: courseCatalogCancelToken.token
  });

  return { coursesCatalog: data };
}

export async function fetchLessonsCatalog(
  filterUrlString: string,
  page?: ILessonsCatalog['nextPage']
): Promise<ILessonsCatalogGetResponse> {
  if (lessonCatalogCancelToken !== undefined) {
    lessonCatalogCancelToken.cancel(REQUEST_IS_CANCELED_MESSAGE);
  }

  lessonCatalogCancelToken = CancelToken.source();

  const searchParams = new URLSearchParams(filterUrlString);

  if (page !== null && page !== undefined) {
    searchParams.append('page', page.toString());
  }
  searchParams.append('per_page', LESSONS_PER_PAGE);

  const { data } = await getApi().get('/lessons', {
    params: searchParams,
    cancelToken: lessonCatalogCancelToken.token
  });

  return { lessonsCatalog: data };
}

export async function fetchSkills(): Promise<ISkillGetResponse> {
  const { data } = await getApi().get(`/skills`);

  return data;
}
